<div class="all-available-plans-modal modal-theme2">
  <div class="modal-header-custom">
    <h2 class="modal-title-custom">{{ headerLabel }}</h2>
    <button class="close-button d-flex d-lg-none" (click)="close()">
      <em class="icon-liteicon-close"></em>
    </button>
  </div>

  <div class="all-available-plans-modal-table" #plansContainer>
    <div class="plans-cards cards-available">
      <button class="close-button d-none d-lg-flex" (click)="close()">
        <em class="icon-liteicon-close"></em>
      </button>
      <ng-container
        *ngIf="userSubscriptionList?.length && !isLoading; else noDataFound"
      >
        <div
          *ngFor="let subscription of userSubscriptionList"
          class="plan-card"
          [class.plan-card--inactive]="!subscription?.active"
        >
          <ng-container *ngIf="subscription?.active">
            <div class="plan-card__header">
              <h3 class="plan-card__title" title="{{ subscription?.name | uppercase }}">
                {{ subscription?.name | uppercase }}
              </h3>
              <span
                *ngIf="subscription?.subscribed"
                class="plan-card__badge plan-card__badge--active"
              >
                <span class="checkmark icon-liteicon-black-tick"></span>
                {{ labels.ACTIVE }}
              </span>
            </div>

            <div class="plan-card__price-block-container">
              <div class="plan-card__price-block">
                <p class="plan-card__price-label">
                  {{ labels.PRICE_FOR }}
                  {{ getDurationLabel(getSelectedPlan(subscription)) }}
                </p>
                <div class="d-flex align-items-center flex-row gap-2">
                <ng-container *ngIf="getSelectedPlan(subscription) as plan">
                  <p class="plan-card__price">
                    {{
                    (plan.price | priceDiscount: plan.discount) | currency : plan.currency_symbol
                    }}
                  </p>
                </ng-container>
                  <span
                    *ngIf="
                      getSelectedPlan(subscription)?.discount &&
                      getSelectedPlan(subscription)?.discount !==
                        Application.STR_ZERO
                    "
                    class="plan-card__discount"
                  >
                    {{ getSelectedPlan(subscription)?.discount }}%
                    {{ labels.OFF_MONTHLY_PRICE }}
                  </span>
                </div>
              </div>

              <div class="plan-card__durations">
                <button
                  *ngFor="let plan of subscription?.plan_details"
                  type="button"
                  class="duration-pill"
                  [class.duration-pill--active]="
                    getSelectedPlan(subscription)?.duration === plan?.duration
                  "
                  (click)="setSelectedPlan(subscription, plan)"
                >
                  {{
                    plan?.duration === Application.ONE
                      ? plan?.duration + ' ' + labels.MONTH
                      : plan?.duration + ' ' + labels.MONTHS
                  }}
                </button>
              </div>

              <div class="plan-card__benefits">
                <p class="plan-card__benefits-title">{{ labels.INCLUDED_BENEFITS }}</p>
                <div class="benefits-list-container">
                  <div class="benefits-list-content">
                    <div class="all-subscription-list" *ngIf="getSelectedPlan(subscription)?.expMer?.length">
                      <app-benefit-code-accordion
                        *ngFor="let benefit of getSelectedPlan(subscription)?.expMer"
                        [benefit]="benefit"
                        [showAccordionText]="CREATE_PLAN_CONSTANTS.DETAILS"
                        [hideAccordionText]="CREATE_PLAN_CONSTANTS.DETAILS"
                      ></app-benefit-code-accordion>
                    </div>
                    <div
                      *ngIf="
                        subscription?.free_dms_count ||
                        subscription?.is_unlimited_free_dms
                      "
                      class="dm-benefit"
                    >
                      <em class="icon-litefree-dms-count"></em>
                      <div class="dm-benefit__text">
                        <span class="dm-benefit__primary">
                          <ng-container
                            *ngIf="
                              subscription?.is_unlimited_free_dms;
                              else finiteDms
                            "
                          >
                            {{
                              Application.FREE_DIRECT_MESSAGES_PER_MONTH.replace(
                                '[quantity]',
                                Application.UNLIMITED
                              )
                            }}
                          </ng-container>
                          <ng-template #finiteDms>
                            {{
                              Application.FREE_DIRECT_MESSAGES_PER_MONTH.replace(
                                '[quantity]',
                                subscription?.free_dms_count
                              )
                            }}
                          </ng-template>
                        </span>
                        <span
                          *ngIf="
                            !subscription?.is_unlimited_free_dms &&
                            userProfile?.price_for_dm > Application.ZERO
                          "
                          class="dm-benefit__secondary"
                        >
                          {{
                            Application.REGULAR_PRICE_FOR_MESSAGE.replace(
                              '[price]',
                              userProfile?.price_for_dm | currency
                            )
                          }}
                        </span>
                      </div>
                    </div>
                    <ul class="benefits-list">
                      <li *ngFor="let feature of subscription?.features">
                        <em class="icon-litewhite-tick-mark"></em>
                        <span>{{ feature }}</span>
                      </li>
                    </ul>

                  </div>
                </div>
              </div>

              <button
                type="button"
                class="plan-card__select-btn"
                [class.plan-card__select-btn--disabled]="
                  isConfirmDisabled(getSelectedPlan(subscription))
                "
                [disabled]="isConfirmDisabled(getSelectedPlan(subscription))"
                (click)="
                  onSelectPlan(subscription, getSelectedPlan(subscription))
                "
              >
                <span
                  *ngIf="showSelectSpinner(subscription)"
                  class="loading-spinner"
                ></span>
                {{ getConfirmButtonLabel(getSelectedPlan(subscription)) }}
              </button>
            </div>
          </ng-container>
        </div>
      </ng-container>
    </div>

    <ng-template #noDataFound>
      <div
        class="sub-empty-state"
        *ngIf="!userSubscriptionList?.length && !isLoading"
      >
        {{ labels.NO_PLAN_AVAILABLE }}
      </div>

      <div *ngIf="isLoading" class="sub-empty-state">
        <span class="loading-spinner"></span>
        {{ labels.LOADING_SUBS }}
      </div>
    </ng-template>
  </div>
</div>
